import React from 'react';
import Navigation from '../components/Navigation/Navigation.jsx';
import HomeHero from '../components/Home/HomeHero';
import { PALETTE_3 } from '../assets/colors';

const Home = () => {
    return (
        <div style={{background: `${PALETTE_3.GREY}`}}>
            <Navigation page="work" />
            <HomeHero />
        </div>
    );
}

export default Home;